import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Tooltip } from 'antd';
import { useDrag } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { useTranslation } from 'react-i18next';
import { DYNAMIC_TABLE_OPERATIONS } from './translationValues';
import { ColumnResizer } from '../styles';

const NAMESPACES = ['DYNAMIC_TABLE_OPERATIONS'];

const ResizableColumn = (props) => {
  const { itemUUID, uuid, columnIndex, left, onResize, onAddColumn, scaling, isResizable = true, customClassName = '', isStatic = false } = props;
  const [isTop, toggleTop] = useState(true);
  const ref = useRef(null);
  const { t } = useTranslation(NAMESPACES);

  const [ , drag, preview ] = useDrag({
    item: {
      uuid,
      itemUUID,
      columnIndex,
      type: "col-resize",
    },
    begin: () => ({
      uuid,
      itemUUID,
      columnIndex,
      type: "col-resize",
    }),
    end: (item, monitor) => {
      onResize(
        uuid,
        columnIndex,
        (monitor.getSourceClientOffset().x - monitor.getInitialSourceClientOffset().x) / scaling
      );
    },
    collect: monitor => ({
      isResizing: !!monitor.isDragging()
    })
  });

  useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true });
  }, [preview]);

  const onMouseOver = useCallback((e) => {
    e.persist();
    const bounds = ref.current?.getBoundingClientRect();
    toggleTop(previousValue => {
      return bounds?.height > 40.5 ? e.nativeEvent.clientY < (bounds?.top + (bounds?.height / 2)): true;
    });
  }, []);

  if (isResizable) {
    drag(ref);
  }

  const extraStyles = isTop ? { top: 0 } : { top: 'calc(100% - 20px)' };

  return (
  <>
      <ColumnResizer ref={ref} left={left} leftStart={props.leftStart} isResizable={isResizable} isStatic={isStatic} className={customClassName}
        onMouseOver={onMouseOver}
      >
          <Tooltip
            title={t(DYNAMIC_TABLE_OPERATIONS.ADD_COLUMN.key, DYNAMIC_TABLE_OPERATIONS.ADD_COLUMN.value)}
          >
            <div className={`addColumnOptions hoverButton ${isTop ? 'top' : 'bottom'}`}
              id={`add-col-${itemUUID}-${columnIndex}`}
              style={{ left: '-10px', ...extraStyles }}
              onClick={onAddColumn}
            >
              +
            </div>
          </Tooltip>
      </ColumnResizer>
    </>
  )
}

export default ResizableColumn;